<template>
   <div v-if="userDetails.company.companysettings.has_payroll">
  <div v-if="!isDetailed">
        <div class="d-flex justify-content-between align-items-center mb-3 py-5">
        <div>
            <h4 class="mb-0 text-primary">Payroll Batches</h4>
            <small class="small-muted">History & recent payroll runs</small>
        </div>
        <div>
            <button v-if="isAdmin" class="btn btn-primary mr-2" v-b-modal="'generate-payroll-modal'"><i class="fa fa-play mr-1"></i> Generate Payroll</button>
            <button class="btn btn-outline-secondary" @click="refresh" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            Refresh
            </button>
        </div>
        </div>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>

        <div class="card card-ghost mb-3">
        <div class="card-body p-0">
            <table class="table mb-0">
            <thead>
                <tr>
                <th>#</th>
                <th>Period</th>
                <th>Status</th>
                <th>Employees</th>
                <th class="text-right">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(batch,index) in batches" :key="batch.id">
                <td>{{ index + 1 }}</td>
                <td>
                    <div>{{ formatDate(batch.meta.periodStart,'DD MMM YYYY') }} To {{ formatDate(batch.meta.periodEnd,'DD MMM YYYY') }}</div>
                    <small class="small-muted">{{ batch.meta && batch.meta.rules_applied ? (batch.meta.rules_applied.join(', ')) : '' }}</small>
                </td>
                <td>
                    <span :class="statusClass(batch.status)">{{ batch.status || 'open' }}</span>
                </td>
                <td>{{ batch.payrolls_count || '-' }}</td>
                <td class="text-right">

                    <div class="btn-group">
                    <a type="button" data-toggle="dropdown">
                        <i class="bi bi-three-dots-vertical"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click.prevent="download(batch.id,'pdf')">PDF</a>
                        <a class="dropdown-item" @click.prevent="download(batch.id,'xlsx')">Excel</a>
                        <a class="dropdown-item text-danger"  @click="confirmDelete(batch)">Delete</a>
                    </div>
                    </div>


                </td>
                </tr>

                <tr v-if="!batches.length && !loading">
                <td colspan="5" class="text-center p-5 small-muted">
                    <p>No payroll runs found.</p>
                    <a v-if="isAdmin" class="btn btn-primary mr-2" @click="goGenerate"><i class="fa fa-play mr-1"></i> Generate Payroll</a>

                </td>

                </tr>
            </tbody>
            </table>
        </div>
        </div>

        <nav v-if="meta.total > meta.per_page" aria-label="Page navigation">
        <ul class="pagination">
            <li class="page-item" :class="{disabled: meta.current_page===1}">
            <a class="page-link" href="#" @click.prevent="fetch(meta.current_page-1)">Previous</a>
            </li>
            <li class="page-item disabled">
            <span class="page-link">Page {{ meta.current_page }} / {{ meta.last_page }}</span>
            </li>
            <li class="page-item" :class="{disabled: meta.current_page===meta.last_page}">
            <a class="page-link" href="#" @click.prevent="fetch(meta.current_page+1)">Next</a>
            </li>
        </ul>
        </nav>

        <modal v-model="showConfirm" title="Delete payroll" message="Are you sure you want to permanently delete this payroll run? This action cannot be undone." :busy="busyDelete" @confirm="doDelete"></modal>
        <b-modal hide-header hide-footer id="generate-payroll-modal">
                        <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
            <h4 class="mb-0">Generate Payroll</h4>
            <small class="small-muted">Create payroll for a monthly period</small>
        </div>
        </div>

        <div class="card card-ghost p-3">
        <form @submit.prevent="submit">
            <div class="form-row">
            <div class="form-group col-md-6">
                <label>Payroll month</label>
                <input type="month" class="form-control" v-model="month" required>
                <small class="form-text text-muted">Pick the month to generate payroll for.</small>
            </div>

            <div class="form-group col-md-6">
                <label>Employees</label>
                <select class="form-control" v-model="employeeFilter">
                <option :value="null">All employees</option>
                <!-- <option v-for="e in employeesList" :key="e.id" :value="e.id">{{ e.name || e.full_name || 'Emp ' + e.id }}</option> -->
                </select>
                <small class="form-text text-muted">Leave as "All" to run payroll for the whole company.</small>
            </div>


            </div>
            <div class="form-group align-self-end text-right">

                <button class="btn btn-primary" :disabled="submitting">
                <span v-if="submitting" class="spinner-border spinner-border-sm mr-2"></span>
                Generate
                </button>
            </div>

            <div v-if="error" class="alert alert-danger mt-2">{{ error }}</div>
            <div v-if="success" class="alert alert-success mt-2">{{ success }}</div>
        </form>
        </div>

        <!-- <div class="mt-3">
        <h6>Recent runs</h6>
        <small class="small-muted">Quick access to recent payroll batches</small>
        <div v-if="recent.length" class="mt-2">
            <ul class="list-group">
            <li v-for="r in recent" :key="r.id" class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                <strong>{{ formatDate(r.payroll_date) }}</strong>
                <div class="small-muted">{{ r.status || 'open' }}</div>
                </div>
                <div>
                <router-link :to="{ name:'payroll.show', params: { id: r.id } }" class="btn btn-sm btn-light mr-2">View</router-link>
                <a href="#" @click.prevent="download(r.id, 'pdf')" class="btn btn-sm btn-outline-secondary">Download</a>
                </div>
            </li>
            </ul>
        </div>
        <div v-else class="small-muted mt-2">No recent runs</div>
        </div> -->

    </b-modal>
    </div>
<div v-else>
    <div class="container">
   <div class="d-flex justify-content-between mb-3 py-5">
      <div>
        <h4>Payroll Details</h4>
        <small class="small-muted">{{ batchTitle }}</small>
      </div>
      <div>
        <router-link :to="{name:'payroll.index'}" class="btn btn-outline-secondary mr-2">Back</router-link>
        <div class="btn-group">
          <button class="btn btn-primary" @click="download(isDetailed, 'pdf')">Download PDF</button>
          <button class="btn btn-outline-secondary" @click="download(isDetailed, 'xlsx')">Export Excel</button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="text-center py-5"><span class="spinner-border"></span></div>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <div v-if="payroll">
      <div class="card card-ghost mb-3 p-3">
        <div class="row">
          <div class="col-md-6">
            <h6>Run</h6>
            <p class="mb-1"><strong>Period:</strong> {{ formatDate(payroll.payroll_date) }}</p>
            <p class="mb-1"><strong>Status:</strong> <span class="badge badge-info">{{ payroll.status || 'open' }}</span></p>
          </div>
          <div class="col-md-6 text-right">
            <h6>Totals</h6>
            <p class="mb-1"><strong>Gross total:</strong> {{ currency(total('gross_salary')) }}</p>
            <p class="mb-1"><strong>Net total:</strong> {{ currency(total('net_salary')) }}</p>
            <p class="mb-1"><strong>Total PAYE:</strong> {{ currency(totalDeductions('PAYE')) }}</p>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-body p-0">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Earnings</th>
                <th>Deductions</th>
                <th>Net</th>
                <th>Payslip</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="e in payroll.employees" :key="e.id">
                <td>{{ e.name }}</td>
                <td>{{ currency(e.earnings || e.gross) }}</td>
                <td>
                  <div v-for="(d, idx) in e.deductions || []" :key="idx">
                    <small>{{ d.type || d.deduction_type }}: {{ currency(d.amount) }}</small><br>
                  </div>
                </td>
                <td>{{ currency(e.net_pay || e.net_salary) }}</td>
                <td>
                  <a v-if="e.payslip_url" :href="e.payslip_url" target="_blank" class="btn btn-sm btn-light">Download</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <router-link :to="{name:'payroll.deductions', params:{ id: payroll.id }}" class="btn btn-outline-secondary">Manage Deductions</router-link>
    </div>
    </div>

</div>
</div>
<div v-else>
  <div class="d-flex vh-100 align-items-center justify-content-center">
    <div class="text-center">
      <h3 class="mb-1">
        Payroll is available exclusively on Dukakit Premium (Ksh 3,000/pm).
      </h3>
      <p>
        Upgrade today to unlock full payroll management, including salary processing,
        deductions, and downloadable reports—all in one place.
      </p>
      <p class="mt-3"><a class="btn btn-primary" href="/payroll?source=internal">Upgrade Now</a></p>
    </div>
  </div>
</div>

</template>

<script>
import { downloadFile } from '../../services/pdfDownload';
import moment from 'moment';
import Modal from './Modal.vue';
  import {
        mapGetters
    } from 'vuex'

export default {
  components: { Modal },
  data() {
    return {
      batches: [],
      loading: false,
      error: null,
      meta: { current_page:1, last_page:1, per_page:10, total:0 },
      showConfirm: false,
      deletingBatch: null,
      busyDelete: false,
       month: this.defaultMonth(),
      employeeFilter: null,
      employeesList: [],
      submitting: false,
      error: null,
      success: null,
      recent: []
    };
  },

  computed: {
    ...mapGetters(['userDetails']),

    isAdmin() {
      try {
        // Prefer Vuex userDetails first if available
        const user = this.userDetails || JSON.parse(localStorage.getItem('user'))

        return user && user.roles[0].name === 'Admin'
      } catch (e) {
        return false
      }
    },
isDetailed() {
  try {


      const params = new URLSearchParams(window.location.search)
      const id = params.get('id')

      if (id) {
        return id
      }

    }
    catch (e) {
    return false
  }
}

  },

  created() { this.fetch(1) },
  methods: {
    defaultMonth() {
      // returns `YYYY-MM` for current month
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
    },
    fetch(page=1) {
      this.loading = true; this.error = null;
      const link = (this.isDetailed) ? `/api/payroll/${this.isDetailed}` : `/api/payroll`
      axios.get(link, { params: { page } })
        .then(res => {


            if(this.isDetailed)
            {
                this.payroll = res.data
            }
            this.batches = res.data;


        })
        .catch(err => { this.error = err.response && err.response.data.message ? err.response.data.message : 'Failed to fetch payroll runs.' })
        .finally(()=> this.loading = false);
    },
    refresh() { this.fetch(this.meta.current_page) },
    formatDate(d,format='YYYY-MM-DD') {
        if (!d)
        return '-';
    return moment(d).format(format) },
    statusClass(s) { if(!s) return 'badge badge-success'; if(s==='locked' || s==='closed') return 'badge badge-secondary'; return 'badge badge-info'; },
    goGenerate() { this.$router.push({name:'payroll.generate'}); },
    async download(id, fmt = 'pdf') {
      try {
        await downloadFile(`/api/payroll-download/${id}?format=${fmt}`, `payroll.${fmt}`);
      } catch (error) {
        this.$toasts.push({ type: 'error', message: 'Could not download the payroll. Please try again.' });
      }
    },
    confirmDelete(batch) {
      this.deletingBatch = batch; this.showConfirm = true;
    },
    doDelete() {
      if (!this.deletingBatch) return;
      this.busyDelete = true;
      axios.delete(`/payroll/${this.deletingBatch.id}`)
        .then(()=> {
          this.showConfirm = false;
          this.deletingBatch = null;
          this.refresh();
        })
        .catch(()=> { alert('Delete failed'); })
        .finally(()=> this.busyDelete = false);
    },
    fetchRecentPayrollsRun() {
      axios.get('/payroll').then(res => {
        const data = res.data.data || res.data;
        this.recent = (data || []).slice(0,5);
      }).catch(()=>{});
    },

    reset(){ this.month = this.defaultMonth(); this.employeeFilter = null; this.success = null; this.error = null; },

    submit() {
      this.error = null; this.success = null; this.submitting = true;
      // build period_end as last day of month
      const [y, m] = this.month.split('-');
      const lastDate = new Date(y, parseInt(m), 0).getDate();
      const periodEnd = `${y}-${m}-${String(lastDate).padStart(2,'0')}`; // e.g. 2025-08-31

      const payload = { period_end: periodEnd };
    //   if (this.employeeFilter) payload.employee_ids = [this.employeeFilter];

      axios.post('/api/payroll', payload)
        .then(res => {
          this.success = res.data.message || 'Payroll generated successfully.';
        //   this.fetchRecentPayrollsRun();
          window.location.href = '/payroll'
        })
        .catch(err => {
          this.error = (err.response && err.response.data && err.response.data.message) || 'Failed to generate payroll.';
        })
        .finally(()=> this.submitting = false);
    }

  }
};
</script>
